import { reportError, toErrorString } from "../utils/errorLogger";

export function isDecryptedValidData(data) {
    try {
        // Check if data is a string
        if (typeof data !== 'string') {
            return false;
        }

        // Check if data is empty or just whitespace
        if (!data.trim()) {
            return false;
        }

        // Check for common corruption indicators
        const corruptionPatterns = [
            /�/g,             // Replacement character often seen in corruption
            /\x00/g,          // Null bytes
            /[\x01-\x1F]/g    // Control characters (excluding printable ASCII)
        ];

        // If any corruption pattern matches significantly, consider it invalid
        for (let pattern of corruptionPatterns) {
            const matches = (data.match(pattern) || []).length;
            if (matches > data.length * 0.1) { // More than 10% corrupted characters
                return false;
            }
        }
        // Try to parse as JSON if it looks like JSON
        if (data.trim().startsWith('{') && data.trim().endsWith('}')) {
            JSON.parse(data);
            return true;
        }

        // For non-JSON, just check if it's readable text
        return data.length > 0 && !data.includes('�');

    } catch (error) {
        const userName = localStorage.getItem('UserName');
        const errorStr = toErrorString(error || error.message);
        reportError({
            endpoint: '-',
            message: `FileName: contractHelper.js, Fun: isDecryptedValidData, ${String(error.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
            level: 'warn',
        });
        console.error('Error during validation:', error);
        return false; // If JSON parsing fails or any other error occurs
    }
}